import React from 'react';
import { Table, Form } from 'react-bootstrap';
import { useState, useEffect } from 'react';
import Select from 'react-select';
import { postRequestOptions, getRequestOptions } from "../helpers/Fetchwrapper";
import { Card } from 'react-bootstrap-v5';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { numberFormat } from '../helpers/GlobalHelper';

interface SalesData {
    months: {
        [month: string]: {
            items: {
                productName: string;
                packing: string;
                unitName: string;
                size?: number;
                deliveredQuantity: number;
                deliveredAmount: number;
                remarks: string;
            }[];
            totalSales: number;
        };
    };
    grandTotalSales: number;
}

const ProductWiseSalesReport: React.FC = () => {
    const [loading, setLoading] = useState(false);
    const [salesData, setSalesData] = useState<SalesData | null>(null);  // Initialize as null
    const [formData, setFormData] = useState({
        idProjects: '',
        idSrCategories: '',
        fromDate: '',
        toDate: '',
    });

    const [projects, setProjects] = useState<{ label: string; value: string }[]>([]);
    const [project, setProject] = useState<{ label: string; value: string }>({ label: 'Select Project', value: '' });

    const [categories, setCategories] = useState<{ label: string; value: string; id?: any; name?: string }[]>([]);
    const [category, setCategory] = useState<{ label: string; value: string }>({ label: 'Select SR Category', value: '' });

    useEffect(() => {
        getProjects();
    }, []);

    useEffect(() => {
        if(projects.length>0){
            setProject(projects[0]);
            setFormData({
                ...formData,
                idProjects: projects[0].value,
            });
            getCategories(projects[0].value);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [projects])

    const getProjects = () => {
        fetch(
            process.env.REACT_APP_API_URL + 'lead/projects',
            getRequestOptions()
        )
            .then((resp) => resp.json())
            .then((resp) => {
                let projectObj = resp.data.map((item: any) => ({
                    label: item.name,
                    value: item.id,
                }));
                setProjects(projectObj);
            })
            .catch((error) => {
                console.error('Error fetching projects:', error);
            });
    };

    const getCategories = async (idProjects: any) => {
        const url = process.env.REACT_APP_API_URL + 'allSrCategory?idProjects=' + idProjects
        const response = await fetch(url, getRequestOptions())
        const data = await response.json()

        data.map((element: any) => {
            element.value = element.id_sr_categories;
            element.label = element.sr_category_name;
            return element;
        })

        var allCategoriesOpt = [{ id: '', name: '', label: 'All', value: '' }]
        let allCategories = data.concat(allCategoriesOpt);
        setCategories(allCategories);

        if (data.length === 1) {
            setCategory(data[0]);
            setFormData((prev) => ({ ...prev, idSrCategories: data[0].value }));
            return;
        }

        // categories list exists but no specific selection -> default to "All"
        const allOpt = allCategories.find((c: any) => c.value === '') || allCategoriesOpt[0];
        setCategory(allOpt);
        setFormData((prev) => ({ ...prev, idSrCategories: '' }));
    }

    const handleProjectChange = (project: any) => {
        setProject(project);
        setFormData({ ...formData, idProjects: project ? project.value : '' });
        if (project && project.value) {
            getCategories(project.value);
        }
    };

    const handleCategoryChange = (category: any) => {
        setCategory(category);
        if(category){
            setFormData({ ...formData, idSrCategories: category.value });
        }else{
            setFormData({ ...formData, idSrCategories: '' });
        }
    }

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = event.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleViewReport = async () => {
        setLoading(true);
        try {
            const response = await fetch(
                process.env.REACT_APP_API_URL + 'reports/product-wise-sales',
                postRequestOptions(formData)
            );
            const data = await response.json();
            if (data.success) {
                setSalesData(data.data);
            } else {
                setSalesData(null);
                for (const i in data.errors) {
                    toast(<strong>{data.errors[i].join(' ')}</strong>, {
                        type: 'error',
                        position: 'bottom-right',
                        autoClose: 4000,
                    });
                }
            }
        } catch (error) {
            console.error('Error submitting data:', error);
        } finally {
            setLoading(false);
        }
    };

    const queryParams = new URLSearchParams(Object.entries(formData).map(([key, value]) => [key, String(value || '')]));

    
    return (
        <>
            <Card className='mb-4'>
                <Card.Body>
                    <Card.Text>
                        <div className='row'>
                            <div className='col-md-2'>
                                <Form.Group className="mb-3" controlId="project">
                                    <Form.Label>Project<span className='required'></span></Form.Label>
                                    <Select
                                        value={project}
                                        onChange={handleProjectChange}
                                        options={projects}
                                        menuPosition="fixed"
                                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                        isClearable={true}
                                    />
                                </Form.Group>
                            </div>
                            <div className='col-md-2'>
                                <Form.Group className="mb-3" controlId="category">
                                    <Form.Label>Select SR Category</Form.Label>
                                    <Select
                                        value={category}
                                        onChange={handleCategoryChange}
                                        options={categories}
                                        placeholder={category.label}
                                        menuPosition="fixed"
                                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                    />
                                </Form.Group>
                            </div>
                            <div className='col-md-2'>
                                <Form.Group className="mb-3">
                                    <Form.Label>From Date<span className='required'></span></Form.Label>
                                    <Form.Control type="date" placeholder="From Date" name='fromDate' value={formData.fromDate} onChange={handleChange} />
                                </Form.Group>
                            </div>
                            <div className='col-md-2'>
                                <Form.Group className="mb-3">
                                    <Form.Label>To Date<span className='required'></span></Form.Label>
                                    <Form.Control type="date" placeholder="To Date" name='toDate' value={formData.toDate} onChange={handleChange} />
                                </Form.Group>
                            </div>
                            <div className='col-md-4'>
                                <div className="form-control-sm ps-0 mt-7">
                                    <button className='btn btn-sm btn-primary p-3' onClick={handleViewReport} disabled={loading}>
                                        {loading && <span className="spinner-border spinner-border-sm"></span>}
                                        <span><i className='fas fa-eye'></i> View Report</span>
                                    </button>
                                    <a className="btn btn-sm btn-primary p-3 ms-3" href={`${process.env.REACT_APP_BACKEND}product_wise_sales_report_download?${queryParams.toString()}`}><i className='fas fa-download'></i> Excel Download</a>
                                    <a className="btn btn-sm btn-primary p-3 ms-3" href={`${process.env.REACT_APP_BACKEND}product_wise_sales_report_print?${queryParams.toString()}`}><i className='fas fa-print'></i> Print</a>
                                </div>
                            </div>
                        </div>
                    </Card.Text>
                </Card.Body>
            </Card>

            <div className='row'>
                <div className='col-12'>
                    {salesData ? (
                        <Table responsive striped bordered hover>
                            <thead>
                                <tr>
                                    <th>Month</th>
                                    <th>Product</th>
                                    <th>Packing ({project.value === 1 ? 'Ltr' : 'mm'})</th>
                                    <th>Sales Qty</th>
                                    <th>Unit</th>
                                    <th>Total Qty ({project.value === 1 ? 'Ltr' : 'mm'})</th>
                                    <th>Sales Value</th>
                                    <th>Remarks</th>
                                </tr>
                            </thead>
                            <tbody>
                                
                                {Object.keys(salesData.months).map((month, monthIndex) => (
                                    <React.Fragment key={monthIndex}>
                                        {salesData.months[month].items.map((item, itemIndex) => (
                                            <tr key={`${monthIndex}-${itemIndex}`}>
                                                {itemIndex === 0 && (
                                                    <td rowSpan={salesData.months[month].items.length}>
                                                        {month}
                                                    </td>
                                                )}
                                                <td>{item.productName}</td>
                                                <td>{item.packing}</td>
                                                <td className='text-end'>{numberFormat(item.deliveredQuantity)}</td>
                                                <td>{item.unitName || ''}</td>
                                                <td className='text-end'>{numberFormat((parseFloat(String(item.size ?? 0)) || 0) * item.deliveredQuantity)}</td>
                                                <td className='text-end'>{numberFormat(item.deliveredAmount)}</td>
                                                <td>{item.remarks ?? ''}</td>
                                            </tr>
                                        ))}
                                        {salesData.months[month].items.length>0 && (
                                            <tr key={`monthly-total-${monthIndex}`}>
                                                <td colSpan={5} className='text-end'><strong>Monthly Total:</strong></td>
                                                <td className='text-end'><strong>{numberFormat(salesData.months[month].items.reduce((sum: number, item: any) => sum + ((parseFloat(String(item.size ?? 0)) || 0) * item.deliveredQuantity), 0))}</strong></td>
                                                <td className='text-end'><strong>{numberFormat(salesData.months[month].totalSales)}</strong></td>
                                                <td></td>
                                            </tr>
                                        )}
                                    </React.Fragment>
                                ))}
                                <tr key={`grand-total`}>
                                    <td colSpan={5} className='text-end'><strong>Grand Total:</strong></td>
                                    <td className='text-end'><strong>{numberFormat(Object.keys(salesData.months).reduce((sum: number, month: string) => sum + salesData.months[month].items.reduce((s: number, item: any) => s + ((parseFloat(String(item.size ?? 0)) || 0) * item.deliveredQuantity), 0), 0))}</strong></td>
                                    <td className='text-end'><strong>{numberFormat(salesData.grandTotalSales)}</strong></td>
                                    <td></td>
                                </tr>
                            </tbody>
                        </Table>

                    ) : (
                        <div>No data available</div>
                    )}
                </div>
            </div>
        </>
    );
};

export default ProductWiseSalesReport;